// libs
import React, { useCallback } from 'react'
import { useTriggerBlock } from 'src/pages/hooks/hooks'
import { useSelectIsUserLoggedIn } from 'src/reducers/user/user_hooks'
import { getConfigValue } from 'src/utils/config/config'

// constants & interfaces
import { PROFILES_SEARCH_QUERY_KEY } from 'src/constants/urls'

// components
import { CategorizedView, SearchView } from './views'

// helpers
import { useGetQueryParam, useSetQueryParam } from 'src/hooks_shared/use_url_search_param'
import { IMarker } from 'src/interfaces/marker'
import initTracker, { PROFILE_DIRECTORY } from 'src/utils/reporting/events_tracking/events_tracking'

const tracker = initTracker(PROFILE_DIRECTORY)

type Props = {
  setMarkers: (markers: IMarker[]) => void;
}

const ProfilesDirectoryCategorized: React.FC<Props> = ({ setMarkers }) => {
  const query = useGetQueryParam(PROFILES_SEARCH_QUERY_KEY) || ''
  const setUrlQueryParam = useSetQueryParam(PROFILES_SEARCH_QUERY_KEY)

  const isUserLoggedIn = useSelectIsUserLoggedIn()

  const onSubmit = useCallback((newQuery: string) => {
    const cleanedQuery = newQuery.trim()
    if (cleanedQuery) {
      tracker(PROFILE_DIRECTORY.ACTIONS.SEARCH, PROFILE_DIRECTORY.LABELS.FINISH)
    }
    setUrlQueryParam(cleanedQuery)
  }, [setUrlQueryParam])

  const shouldHideSearch = !!getConfigValue<boolean>('featureFlags.search.disableSearchForLoggedOut')

  useTriggerBlock(shouldHideSearch && !isUserLoggedIn)

  if (query) {
    return <SearchView onSubmit={onSubmit} query={query} setMarkers={setMarkers} />
  }
  return <CategorizedView onSubmit={onSubmit} query={query} setMarkers={setMarkers} />
}

ProfilesDirectoryCategorized.displayName = 'ProfilesDirectoryCategorized'

export default ProfilesDirectoryCategorized
